import { CrudResource } from "@/components/CrudResource";
import { StatusBadge } from "@/components/StatusBadge";

const STATUS = [
  { value: "active", label: "status.active" },
  { value: "inactive", label: "status.inactive" },
  { value: "suspended", label: "status.suspended" },
];

export default function Vehicles() {
  return (
    <CrudResource
      title="menu.vehicles"
      subtitle="sub.vehicles"
      endpoint="/vehicles"
      testid="vehicles"
      searchPlaceholder="ph.vehicles"
      searchKeys={["brand", "model", "registration_number", "plate", "country", "partner_id", "status", "rca_expiry", "inspection_expiry"]}
      columns={[
        { key: "brand", label: "fld.brand" },
        { key: "model", label: "fld.model" },
        { key: "registration_number", label: "col.regPlate", render: (r) => r.plate || r.registration_number || "—" },
        { key: "capacity_coffins", label: "fld.capacityCoffins", render: (r) => r.capacity_coffins ?? 1 },
        { key: "country", label: "fld.country" },
        { key: "rca_expiry", label: "col.rcaExpiry" },
        { key: "inspection_expiry", label: "col.inspExpiry" },
        { key: "status", label: "common.status", render: (r) => <StatusBadge status={r.status || "active"} /> },
      ]}
      fields={[
        { name: "plate", label: "fld.plate", type: "text" },
        { name: "brand", label: "fld.brand", type: "text" },
        { name: "model", label: "fld.model", type: "text" },
        { name: "type", label: "fld.type", type: "text" },
        { name: "capacity", label: "fld.capacityDesc", type: "text" },
        { name: "capacity_coffins", label: "fld.capacityCoffins", type: "number" },
        { name: "country", label: "fld.country", type: "text" },
        { name: "rca_expiry", label: "fld.rcaExpiry", type: "text" },
        { name: "inspection_expiry", label: "fld.inspExpiry", type: "text" },
        { name: "partner_id", label: "fld.partnerCompany", optionsEndpoint: "/partners", labelKey: "company_name" },
        { name: "status", label: "common.status", type: "select", options: STATUS },
        { name: "active", label: "fld.active", type: "switch" },
      ]}
      bulk={{
        statusOptions: STATUS,
        assignEndpoint: "/partners",
        actions: [
          { key: "export", kind: "export", action: "export", label: "bulk.export", roles: ["admin", "support", "partner"] },
          { key: "status", kind: "status", label: "bulk.status", roles: ["admin", "support", "partner"] },
          { key: "assign", kind: "assign", label: "bulk.assignCompany", roles: ["admin", "support"] },
          { key: "suspend", kind: "suspend", action: "suspend", label: "bulk.suspend", roles: ["admin", "support", "partner"] },
          { key: "delete", kind: "delete", action: "delete", label: "bulk.delete", roles: ["admin", "partner"] },
        ],
      }}
    />
  );
}
